// avatarColor.ts
export const getAvatarColor = (key: string) => {
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }

  const colors = [
    { bg: "bg-red-500", text: "text-white" },
    { bg: "bg-blue-500", text: "text-white" },
    { bg: "bg-green-500", text: "text-white" },
    { bg: "bg-purple-500", text: "text-white" },
    { bg: "bg-orange-500", text: "text-white" },
  ];

  return colors[Math.abs(hash) % colors.length];
};
